import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import InfoIcon from '@mui/icons-material/Info';

export const ChecklistGeneralDataComponent = ({
  checklist,
  onPropertyChanged,
  targetAreas,
  requiredDocTypes,
  validation,
  genericEntityFlows,
  genericEntityBusinessStates
}) => {
  const [t] = useTranslation();

  const onTextFieldChanged = (propName, event) => {
    onPropertyChanged(propName, event ? event : null);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          value={checklist?.targetAreaId}
          simpleValue
          options={targetAreas}
          label={t('Checklist.TargetAreaName')}
          onChange={event => onPropertyChanged('targetAreaId', event)}
          error={!isValid(validation.targetAreaId)}
          helperText={getErrors(validation.targetAreaId)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          value={checklist?.reqDocTypeId}
          simpleValue
          options={requiredDocTypes}
          label={t('Checklist.DocumentName')}
          onChange={event => onPropertyChanged('reqDocTypeId', event)}
          error={!isValid(validation.reqDocTypeId)}
          helperText={getErrors(validation.reqDocTypeId)}
          isSearchable={true}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={checklist?.documentCode || ''}
          InputProps={{
            readOnly: true
          }}
          label={t('Checklist.DocumentCode')}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={checklist?.sharePointContentType || ''}
          InputProps={{
            readOnly: true
          }}
          label={t('Checklist.SharePointContentType')}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          value={checklist?.flowId}
          simpleValue
          options={genericEntityFlows}
          label={t('Checklist.ApprovalFlow')}
          onChange={event => onPropertyChanged('flowId', event)}
          isSearchable={true}
        />
      </Grid>
      <Grid container spacing={2} item xs={12} sm={4}>
        <Grid container wrap='nowrap' item xs={1} sm={1} md={11}>
          <Autocomplete
            fullWidth
            value={checklist?.postUploadStateId}
            simpleValue
            options={genericEntityBusinessStates}
            label={t('Checklist.PostUploadStatus')}
            onChange={event => onPropertyChanged('postUploadStateId', event)}
            isSearchable={true}
          />
          <IconButton color='transparent' tooltip={t('Tooltips.Checklist.InfoUploadFlow')} disabled>
            <InfoIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(checklist?.mandatoryYN) || false}
              onChange={event => onPropertyChanged('mandatoryYN', event.target.checked)}
              color='primary'
            />
          }
          label={t('Checklist.MandatoryYN')}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(checklist?.defaultYN) || false}
              onChange={event => onPropertyChanged('defaultYN', event.target.checked)}
              color='primary'
            />
          }
          label={t('Checklist.DefaultYN')}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={Boolean(checklist?.canExpire) || false}
              onChange={event => onPropertyChanged('canExpire', event.target.checked)}
              color='primary'
            />
          }
          label={t('Checklist.CanExpire')}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        {checklist?.canExpire && (
          <TextField
            isNumeric
            fullWidth
            value={checklist?.validityDays || ''}
            label={t('Checklist.ValidityDays')}
            decimalScale={0}
            onChange={event => {
              onTextFieldChanged('validityDays', event || null);
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

ChecklistGeneralDataComponent.propTypes = {
  checklist: PropTypes.object,
  onPropertyChanged: PropTypes.func.isRequired,
  targetAreas: PropTypes.array.isRequired,
  requiredDocTypes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  genericEntityFlows: PropTypes.array.isRequired,
  genericEntityBusinessStates: PropTypes.array.isRequired
};

export default ChecklistGeneralDataComponent;
